import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AuthService } from '../core/authentication.service';
import {DialogLoginProblemsComponent} from '../login/login.component.resetDialog';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    public isMenuCollapsed = true;

    constructor(
      private location: Location,
      public authService: AuthService,
      public dialog: MatDialog
  ) {}
    ngOnInit() {
    }

      logout() {
        this.authService.doLogout()
            .then((res) => {
              this.location.back();
            }, (error) => {
              console.log('Logout error', error);
            });
      }

    tryReset = () => {
        const dialogRef = this.dialog.open(DialogLoginProblemsComponent, {
            width: '500px',
            data: {
                type: 'passwordChange'
            }
        });
        dialogRef.afterClosed().subscribe(() => {
            console.log('The dialog was closed');
        });
    }

  tryChangeMail = () => {
    const dialogRef = this.dialog.open(DialogLoginProblemsComponent, {
      width: '500px',
      data: {
        type: 'mailChange'
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      console.log('The dialog was closed');
    });
  }

}
